import React, { useEffect, useState } from 'react';

interface Props {
    onDragMove(event: React.PointerEvent<Element>): void;
    onPointerDown?(event: React.PointerEvent<Element>): void;
    onPointerUp?(event: React.PointerEvent<Element>): void;
    onPointerMove?(event: React.PointerEvent<Element>): void;
    children?: React.ReactNode;
    style?: React.CSSProperties;
    className?: string;
}

export const DragMove: React.FC<Props> = ({
    onDragMove,
    onPointerDown = () => {},
    onPointerUp = () => {},
    onPointerMove = () => {},
    children,
    style,
    className
}) => {
    const [isDragging, setIsDragging] = useState(false);

    const handlePointerDown = (event: React.PointerEvent<Element>) => {
        setIsDragging(true);
        onPointerDown(event);
    };

    const handlePointerUp = (event: React.PointerEvent<Element>) => {
        setIsDragging(false);
        onPointerUp(event);
    };

    const handlePointerMove = (event: React.PointerEvent<Element>) => {
        if (isDragging) onDragMove(event);
        onPointerMove(event);
    };

    useEffect(() => {
        // @ts-ignore: DOM event is incompatible to React event
        window.addEventListener('pointerup', handlePointerUp);

        return () => {
            // @ts-ignore: DOM event is incompatible to React event
            window.removeEventListener('pointerup', handlePointerUp);
        };
    }, []);

    return (
        <g onPointerDown={handlePointerDown} onPointerMove={handlePointerMove} style={style} className={className}>
            {children}
        </g>
    );
};
